var app = angular.module('leonardo');

var IconDirective = function(ConfigThemeService) {
  return {
    restrict: 'E',
    scope: {
      iconColor: '@',
      hoverColor: '@',
      changeColor: '@',
      iconOpacity: '@',
      iconImage: '@',
      hoverImage: '@',
      iconHeight: '@',
      iconWidth: '@',
      ngClass: '=?'
    },
    templateUrl: 'views/templates/widget/icon.html',
    link: function (scope, element, attrs) {

      scope.urlImage = '';
      scope.loaded = false;

      scope.getNgClass = function() {
        if (isEmpty(scope.ngClass)) {
          return '';
        }
        else {
          var classes = '';
          angular.forEach(scope.ngClass, function (value, key) {
            if (value){
              classes += ' ' + key;
            }
          });
          return classes;
        }
      };

      scope.setUrl = function(hoverImage) {
        var web_url = ConfigThemeService.config.url_config.web_url;
        if (window.location.origin !== web_url){
          web_url = ConfigThemeService.default_config.url_config.web_url;
        }
        var image_url = hoverImage ? hoverImage : scope.iconImage;
        scope.urlImage = web_url + '/img/' + image_url;
      };

      scope.setPosition = function() {
        element.parent().addClass('relative');
        element.css('height', scope.iconHeight + 'px');
        element.css('width', scope.iconWidth + 'px');
        element.addClass('absolute');
        var positions = attrs.position.split(' ');
        angular.forEach(positions, function (position) {
          switch (position) {
            case 'top':
              element.css('bottom', 'auto');
              break;
            case 'bottom':
              element.css('top', 'auto');
              break;
            case 'left':
              element.css('right', 'auto');
              break;
            case 'right':
              element.css('left', 'auto');
              break;
          }
        });
      };

      scope.setZoneColor = function(zone, color) {
        var changeColor = scope.changeColor ? ConfigThemeService.getDefaultColor(scope.changeColor) : null;
        scope.svg.find(zone).each(function (i) {
          var path = angular.element(this);
          var fill = path.attr('fill');
          var changed = path.attr('changed');
          if (isNull(fill)) {
            fill = path.parent().attr('fill');
          }
          if (fill) {
            fill = fill.toLowerCase();
          }
          if (changed || ((fill !== '#fff') && (fill !== '#ffffff'))) {
            if (changeColor) {
              var colorChanged = changed ? changed.toLowerCase() : changeColor.toLowerCase();
              if (fill === colorChanged) {
                path.attr('fill', color);
                path.attr('changed', color);
              }
            }
            else {
              path.attr('fill', color);
            }
          }
        });
      };

      scope.setColor = function(hoverColor) {
        var colorElement = hoverColor || scope.iconColor;
        var color = null;
        if (colorElement === 'white') {
          color = '#FFFFFF';
        }
        else {
          color = colorElement ? ConfigThemeService.getColor(colorElement, scope.iconOpacity) : null;
        }
        if (scope.svg && scope.svg.length > 0 && color) {
          scope.setZoneColor('path', color);
          scope.setZoneColor('polygon', color);
          scope.setZoneColor('rect', color);
          scope.setZoneColor('circle', color);
        }
      };

      scope.setSVG = function () {
        if (scope.loaded) {
          var svg = element.find('svg');
          if (svg && svg.length > 0) {

            // Remove any invalid XML tags as per http://validator.w3.org
            svg.removeAttr('xmlns:a');

            svg.attr('height', scope.iconHeight);
            svg.attr('width', scope.iconWidth);
            svg.attr('viewBox', '0 0 ' + scope.iconWidth + ' ' + scope.iconHeight);
            svg.mouseover(function() {
              if (!scope.hover) {
                if (scope.hoverColor) {
                  scope.setColor(scope.hoverColor);
                }
              }
              scope.hover = true;
            });
            svg.mouseout(function() {
              if (scope.hover){
                if (scope.hoverColor) {
                  scope.setColor();
                }
              }
              scope.hover = false;
            });
            scope.svg = svg;
            scope.setColor();
            if (attrs.position) {
              scope.setPosition();
            }
          }
        }
      };

      element.addClass('inline');

      scope.setUrl();

      scope.$watch(
        function () {
          return element.attr('class') + scope.getNgClass();
        },
        function (newValue, oldValue) {
          if (!isEquals(newValue, oldValue)) {
            scope.setColor();
          }
        }
      );

      scope.$watch('iconImage',
        function (newValue, oldValue) {
          if (!isEquals(newValue, oldValue)) {
            scope.loaded = false;
            scope.setUrl();
          }
        }
      );

      scope.$watch('iconColor',
        function (newValue, oldValue) {
          if (!isEquals(newValue, oldValue)) {
            scope.setColor();
          }
        }
      );

      scope.$watch('iconOpacity',
        function (newValue, oldValue) {
          if (!isEquals(newValue, oldValue)) {
            scope.setColor();
          }
        }
      );

      scope.$watch('loaded',
        function (newValue, oldValue) {
          if (!isEquals(newValue, oldValue)) {
            if (newValue) {
              scope.setSVG();
            }
          }
        }
      );

      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('icon', ['ConfigThemeService', IconDirective]);
